module.exports = __webpack_public_path__ + "teqbahn-assets/media/5.d9c8dc61.png";